import React from 'react';
import './index.scss';

function HeroSeparator(props) {
    return <section className="hero-separator" style={{ backgroundImage: `url(${props.img})` }}>

    </section>
}

export default HeroSeparator